import { Client } from "./baseurl";

export interface Community {
  id: string;
  name: string;
  description: string;
  provinceId: string;
  provinceName: string;
  link: string;
}

export interface ProvinceCommunities {
  provinceId: string;
  provinceName: string;
  communities: Community[];
}

// GET BACKEND/v1/communities
// La baseURL (REACT_APP_BACKEND_URL) ya incluye el prefijo /v1.
export const getCommunities = async (): Promise<ProvinceCommunities[]> => {
  const response = await Client.get('/communities');
  return response.data;
};

export interface CommunityLink {
  link: string;
}

// GET BACKEND/v1/communities?idLocation=<id>
// Devuelve un objeto con el atributo link de la comunidad correspondiente a la localidad.
export const getCommunityByLocation = async (idLocation: string): Promise<CommunityLink> => {
  const response = await Client.get('/communities', { params: { idLocation } });
  return response.data;
};
